<template>
  <div class="px-6 pb-4 overflow-y-auto flex-grow-1">
    <slot></slot>
  </div>
</template>
